export default __webpack_public_path__ + "static/media/kubernetes.5492fc43.svg";